export default {
      id: "rail-usage",
      viewBox: "0 0 19 31",
      url: __webpack_public_path__ + "img/icons.svg#rail",
      toString: function () {
        return this.url;
      }
    }